import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { UserFeedbackSource } from 'sources'
import { Analytics } from 'common-frontend'
import { AnalyticsUtils } from 'utils'

// Using Actions/Store here even though the logic is simple so we don't keep showing the feedback request to users
//  in different components... could be annoying
@createActions(alt)
export default class UserFeedbackActions {
  constructor() {
    this.generateActions(
      'setEnjoying',
      'setWillReview',
      'setWillFeedback',
      'setDismissed'
    )
  }

  componentDidMount() {
    AnalyticsUtils.feedbackViewed()
  }

  enjoying(isEnjoying, triggerFeedback = false) {
    this.setEnjoying(isEnjoying)
    if (triggerFeedback) {
      window.open('https://plug-in-useful.typeform.com/to/w60Vhf')
    }

    return null
  }

  review(willReview) {
    if (willReview === true) {
      window.open('https://apps.shopify.com/plug-in-seo#modal-show=ReviewListingModal')
    }
    this.setWillReview(willReview)
    return null
  }

  feedback(willFeedback) {
    if (willFeedback === true) {
      document.location = 'mailto:help+pluginseo-feedback@pluginseo.com'
    }
    this.setWillFeedback(willFeedback)
    return null
  }

  dismissed(isDismissed) {
    this.setDismissed(isDismissed)
    return null
  }
}



// WEBPACK FOOTER //
// ./app/actions/UserFeedbackActions.js